module.exports = __webpack_public_path__ + "img/icon-mic-blue-t.6a39259a.png";